<template>
  <div class="store">
    <div class="head">品牌故事</div>
    <main>
      <div class="top rich" v-html="story"></div>
      <div class="option" v-for="(item,index) in info" :key="index">
        <div>
          <p class="en">
            {{item.title}}
            <br />
            <span>{{item.en_title}}</span>
          </p>
          <label for></label>
          <p class="desc text-overflow-more-6 text-overflow-more" v-html="item.content"></p>
        </div>
        <img :src="item.img" alt srcset />
      </div>
    </main>
    <div class="history">
      <h1>發展歷程</h1>
      <p class="en">development path</p>
      <div class="history-wrap pc">
        <img src="../assets/img/prev.png" alt srcset @click="to(active-1)" />
        <swiper ref="swiper" :options="option" class="swiper" v-if="develop.length">
          <swiper-slide v-for="(item,index) in develop" :key="index">
            <div class="box" :class="{active:active == index}" @click="show(index)">
              <div class="hr"></div>
              <div class="c">
                <img src="../assets/img/address-icon.png" alt srcset />
                <span>{{item.title}}</span>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="box">
              <div class="hr"></div>
            </div>
          </swiper-slide>
        </swiper>
        <img src="../assets/img/next.png" alt srcset @click="to(active+1)" />
      </div>
      <div class="history-wrap mobile">
        <div
          class="history-box"
          v-for="(item,index) in develop"
          :key="index"
          @click="active=index;detail=develop[index]"
        >
          <div>
            <div class="c">
              <!-- <img
                :class="{active:active == index}"
                src="../assets/img/address-icon.png"
                alt
                srcset
              />-->
              <div class="hr" v-show="index !==0"></div>
              <i :class="{active:active == index}">
                <i>{{item.title}}</i>
              </i>

              <!-- <span :class="{active:active == index}">{{item.title}}</span> -->
            </div>
          </div>
          <div class="hr"></div>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <p class="title">{{detail.title}}</p>
          <p class="text-overflow-more text-overflow-more-3">{{detail.content}}</p>
        </div>
        <el-image :src="detail.img" fit="fit"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let _this = this;
    return {
      active: 0,
      active1: 0,
      develop: [],
      detail: {},
      info: [],
      story: {},
      option: {
        slidesPerView: 8,
        spaceBetween: 0
      }
    };
  },
  created() {
    this.axios.get("develop/index").then(r => {
      this.develop = [...r];
      this.detail = r[0];
    });
    this.axios.get("about/index").then(r => {
      this.info = [...r];
    });
    this.axios.get("about/story").then(r => {
      this.story = r;
    });
  },
  methods: {
    show(index) {
      this.detail = this.develop[index];
      this.active = index;
    },
    to(index) {
      if (index >= this.develop.length - 1) {
        index = this.develop.length - 1;
      } else if (index == 0) {
        index = 0;
      }
      this.$refs.swiper.swiper.slideTo(index);
      this.show(index);
      this.active = index;
    }
  }
};
</script>

<style lang="less" scoped>
.store {
  background: rgb(251, 251, 251);
  padding: 0.37rem 0;
  main {
    padding: 0 3.6rem;
    .top {
      margin-bottom: 0.8rem;
      padding-top: 0.25rem;
      font-family: unset;
    }
    .option {
      display: flex;
      align-items: flex-end;
      margin-bottom: 1rem;

      & > div {
        width: 6.5rem;
        margin-right: 1.03rem;
      }
      img {
        width: 4rem;
        height: 2.63rem;
      }
      .en {
        text-align: left;
        font-size: 0.18rem;
        font-family: "FZShuSong-Z01T";
        font-weight: 400;

        span {
          font-size: 0.16rem;
          font-family: "Baskerville Old Face";
        }
      }
      label {
        width: 0.66rem;
        height: 0px;
        border: 2px solid rgba(0, 0, 0, 1);
        display: inline-block;
        margin-top: 0.36rem;
        margin-bottom: 0.24rem;
      }
      .desc {
        font-size: 0.14rem;
        // font-family: "FZShuSong-Z01T";
        color: rgba(32, 32, 32, 1);
        line-height: 28px;
      }
    }
  }
  .history {
    background: white;
    padding: 1.25rem 3.6rem;
    .history-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.5rem;
      & > img {
        width: 0.2rem;
        height: 0.2rem;
      }
      .swiper {
        height: 3rem;
        width: 100%;
      }
      .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .box {
        height: 0.2rem;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .hr {
          width: calc(100% - 0.12rem);
          height: 1px;
          background: rgba(0, 0, 0, 0.1);
        }
        .c {
          width: 0.12rem;
          height: 0.12rem;
          border: 1px solid #7f6d46;
          position: relative;
          span {
            padding: 5px;
            background: #7f6d46;
            color: white;
            font-size: 0.14rem;
            // font-family: FZShuSong-Z01T;
            position: absolute;
            bottom: -10px;
            transform: translate(-40%, 100%);
            text-align: center;
            min-width: 0.8rem;
            display: none;
          }
          img {
            width: 0.27rem;
            height: 0.36rem;
            position: absolute;
            top: -10px;
            left: 50%;
            transform: translate(-50%, -100%);
            display: none;
          }
        }

        // .c::before {
        //   width: 0.27rem;
        //   height: 0.36rem;
        //   background: url("../assets/img/address-icon.png") no-repeat;
        //   background-size: contain;
        //   position: absolute;
        //   top: 0;
        //   left: 50%;
        //   transform: translate(-50%, -100%);
        // }
      }
      .box.active {
        .c {
          background: #7f6d46 !important;
          span {
            display: inline-block !important;
          }
          img {
            display: block !important;
          }
        }
      }
    }
    .content {
      display: flex;
      & > * {
        width: 50%;
        height: 4.12rem;
      }
      .left {
        background: black;
        color: white;
        // font-family: "FZShuSong-Z01T";
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 0 0.38rem;
        .title {
          font-size: 0.16rem;
        }
        .text-overflow-more {
          font-size: 0.14rem;
          margin-top: 0.48rem;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  h1 {
    font-size: 22px;
  }
  .en {
    font-size: 16px;
  }
  .store {
    padding: 30px 0;
    main {
      padding: 0 10px;
      .top {
        margin-bottom: 30px;
      }
      .option {
        justify-content: space-between;
        display: block;
        margin-bottom: 30px;
        .desc {
          font-size: 12px;
        }
        & > div {
          width: 100%;
          margin: 0;
        }
        label {
          width: 40%;
        }
        .en {
          font-size: 14px;
          span {
            font-size: 12px;
          }
        }
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .history {
      padding: 20px 10px;
      .history-wrap.mobile {
        width: 100%;
        overflow-x: auto;
        display: block;
        white-space: nowrap;
        margin-bottom: 20px;
        & > div {
          display: inline-block;
          vertical-align: top;

          height: 100px;
          padding-top: 50px;
          box-sizing: border-box;
          .c {
            display: flex;
            align-items: center;
            position: relative;
            i {
              width: 10px;
              height: 10px;
              border: 1px solid #7f6d46;
              margin: 5px 0;
              display: inline-block;
              position: relative;
              i {
                position: absolute;
                opacity: 0;
                font-size: 12px;
                transform: translate(-45%, 100%);
              }
            }
            i.active::before {
              content: " ";
              background-image: url("../assets/img/address-icon.png");
              background-size: 100% 100%;
              display: block;
              width: 20px;
              height: 25px;
              position: absolute;
              left: 50%;
              top: -5px;
              transform: translate(-50%, -100%);
            }
            i.active {
              background: #7f6d46;
              i {
                background: #7f6d46;
                color: white;
                padding: 1px 5px;
                width: unset;
                height: unset;
                opacity: 1;
                border: unset;
              }
            }
            .hr {
              content: " ";
              width: 100px;
              height: 1px;
              display: inline-block;
              background: lightgrey;
            }
            img {
              opacity: 0;
              position: absolute;
              width: 20px;
              transform: translate(50%, -100%);
            }
            img.active,
            span.active {
              opacity: 1;
              right: 0;
            }
            span {
              position: absolute;
              opacity: 0;
              font-size: 12px;
              transform: translate(50%, 100%);
            }
          }
        }
      }
      .content {
        display: block;
        & > * {
          width: 100%;
          height: auto;
        }
        .left {
          padding: 20px;
          box-sizing: border-box;
          .title {
            font-size: 16px;
          }
          .text-overflow-more {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }

  .head {
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about.vue